/**
 * Query-key factory for the View Bureau feature. Keyed by approvalId +
 * applicantId since `BureauApi.getBureauView` is a per-applicant read — one
 * cache entry per applicant on the deal (driver, and secondSigner when
 * present), rather than one combined entry per approval.
 */
export const viewBureauKeys = {
  all: ["view-bureau"] as const,
  details: () => [...viewBureauKeys.all, "detail"] as const,
  detail: (approvalId: string, applicantId: string) => [...viewBureauKeys.details(), approvalId, applicantId] as const,
};
